import {
  GET_FORM_LIST_BEGIN,
  GET_FORM_LIST_ERROR,
  GET_FORM_LIST_SUCCESS,
  SELECTED_LIST_BEGIN,
  SELECTED_LIST_ERROR,
  SELECTED_LIST_SUCCESS,
  TOGGLE_SELECT_BEGIN,
  TOGGLE_SELECT_ERROR,
  TOGGLE_SELECT_SUCCESS,
  SET_SELECTED_PROFILE,
} from "../utils/action";

const Dashboard_reducer = (state, action) => {
  switch (action.type) {
    case GET_FORM_LIST_BEGIN:
      return { ...state, dashboard_loading: true };
    case GET_FORM_LIST_SUCCESS:
      return {
        ...state,
        dashboard_loading: false,
        dashboard_Data: action.payload,
      };
    case GET_FORM_LIST_ERROR:
      return { ...state, dashboard_loading: false };

    case SELECTED_LIST_BEGIN:
      return { ...state, selected_loading: true };
    case SELECTED_LIST_SUCCESS:
      return {
        ...state,
        selected_loading: false,
        selected_data: action.payload,
      };
    case SELECTED_LIST_ERROR:
      return { ...state, selected_loading: false };

    case TOGGLE_SELECT_BEGIN:
      return { ...state, is_select_load: true };
    case TOGGLE_SELECT_SUCCESS:
      return { ...state, is_select_load: false };
    case TOGGLE_SELECT_ERROR:
      return { ...state, is_select_load: false };

    case SET_SELECTED_PROFILE:
      return { ...state, selected_profile: action.payload };

    default:
      return state;
  }
};

export default Dashboard_reducer;
